/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";

import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";

import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Card, CardContent, CardHeader } from "@mui/material";
import React, { useEffect } from "react";
import { Cancel } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import { useSnackbar } from "notistack";
import { PARTY_RATE } from "app/routes/constant";
import { getProductList } from "app/redux/slice/productSlice";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import { createPartyRate } from "app/redux/slice/partyRateSlice";

const AddPartyRate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const productData = useSelector((state) => state?.product);
  const supplierData = useSelector((state) => state?.supplier);

  const mobileView = useMediaQuery("(max-width:575px)");

  const validationSchema = Yup.object({
    products: Yup.array().of(
      Yup.object({
        productId: Yup.object().nullable().required("Please select product"),
        supplierId: Yup.object().nullable().required("Please select supplier"),
        // gst: Yup.string()
        //   .nullable()
        //   .transform((value) => value?.toUpperCase())
        //   .matches(
        //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        //     {
        //       message: "Enter a valid GST number",
        //       excludeEmptyString: true,
        //     },
        //   ),
        price: Yup.number()
          .typeError("Price must be a number")
          .moreThan(0, "Price must be greater than 0")
          .required("Please enter price"),
        // mobileNumber: Yup.string()
        //   .trim()
        //   // .required("Please enter mobile number")
        //   .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
      }),
    ),
  });

  useEffect(() => {
    dispatch(getProductList({ sort: 1, field: "name" }));
    dispatch(getSupplierList({ sort: 1, field: "name" }));
  }, []);

  return (
    <>
      <Card>
        <CardHeader title={`Add Party Rate`} />
        <CardContent>
          <Formik
            initialValues={{
              products: [
                {
                  productId: null,
                  supplierId: null,
                  gst: "",
                  price: "",
                  mobileNumber: "",
                },
              ],
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
            validateOnChange={false}
            onSubmit={async (data, { setSubmitting }) => {
              setSubmitting(true);
              try {
                for (const val of data.products) {
                  const partyRateData = {
                    productId: val?.productId?._id,
                    supplierId: val?.supplierId?._id,
                    gst: val?.gst?.trim()?.toUpperCase() || "",
                    price: Number(val?.price),
                    mobileNumber: val?.mobileNumber,
                  };

                  const response = await dispatch(
                    createPartyRate(partyRateData),
                  ).unwrap();
                  if (response.status === 200) {
                    enqueueSnackbar(response.data?.responseMessage, {
                      variant: "success",
                    });
                  } else {
                    enqueueSnackbar(response.data?.responseMessage, {
                      variant: "error",
                    });
                  }
                }
                navigate(PARTY_RATE);
              } catch (error) {
                enqueueSnackbar("An error occurred", {
                  variant: "error",
                });
              }
              setSubmitting(false);
            }}
          >
            {({ values, errors, isSubmitting, setFieldValue }) => (
              <Form>
                <div>
                  <div>
                    <FieldArray name={`products`}>
                      {({ remove: removeRow, push: pushRow }) => (
                        <div>
                          {values?.products?.length > 0 &&
                            values?.products?.map((valRow, index) => (
                              <div key={index}>
                                <Grid container spacing={3} mb={3}>
                                  {/* Product — always visible */}


                                  {/* Supplier, Mobile Number, GST — first row only */}
                                  {index === 0 && (
                                    <>
                                      <Grid item xs={12} sm={4}>
                                        <JumboAutoComplete
                                          options={supplierData.list ?? []}
                                          label="Supplier*"
                                          size="large"
                                          getOptionLabel={(option) => option?.name}
                                          name={`products[${index}].supplierId`}
                                          value={valRow?.supplierId}
                                          onChange={(evt, value) => {
                                            setFieldValue(
                                              `products[${index}].supplierId`,
                                              value,
                                            );
                                            setFieldValue(
                                              `products[${index}].gst`,
                                              value?.gst
                                                ? value?.gst?.trim()?.toUpperCase()
                                                : "",
                                            );
                                            setFieldValue(
                                              `products[${index}].mobileNumber`,
                                              value?.mobileNumber
                                                ? value?.mobileNumber?.trim()
                                                : "",
                                            );
                                          }}
                                          helperText={
                                            errors?.products?.length &&
                                            errors?.products[index]?.supplierId
                                          }
                                          isOptionEqualToValue={(option, value) =>
                                            option?._id === value?._id
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4}>
                                        <TextField
                                          sx={{ width: "100%" }}
                                          name={`products[${index}].mobileNumber`}
                                          label="Mobile Number"
                                          size="large"
                                          onChange={(e) =>
                                            setFieldValue(
                                              `products[${index}].mobileNumber`,
                                              e.target.value,
                                            )
                                          }
                                          value={valRow?.mobileNumber}
                                          error={
                                            errors?.products?.[index]
                                              ? !!errors.products[index].mobileNumber
                                              : false
                                          }
                                          helperText={
                                            errors?.products?.[index]
                                              ? errors.products[index].mobileNumber
                                              : ""
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4}>
                                        <TextField
                                          sx={{ width: "100%" }}
                                          name={`products[${index}].gst`}
                                          label="GST"
                                          size="large"
                                          onChange={(e) =>
                                            setFieldValue(
                                              `products[${index}].gst`,
                                              e.target.value,
                                            )
                                          }
                                          value={valRow?.gst}
                                          error={
                                            errors?.products?.[index]
                                              ? !!errors.products[index].gst
                                              : false
                                          }
                                          helperText={
                                            errors?.products?.[index]
                                              ? errors.products[index].gst
                                              : ""
                                          }
                                        />
                                      </Grid>
                                    </>
                                  )}
                                  <Grid item xs={12} sm={5}>
                                    <JumboAutoComplete
                                      options={productData.list ?? []}
                                      label="Product*"
                                      size="large"
                                      getOptionLabel={(option) => option?.name}
                                      name={`products[${index}].productId`}
                                      value={valRow?.productId}
                                      onChange={(evt, value) => {
                                        setFieldValue(
                                          `products[${index}].productId`,
                                          value,
                                        );
                                      }}
                                      helperText={
                                        errors?.products?.length &&
                                        errors?.products[index]?.productId
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option?._id === value?._id
                                      }
                                    />
                                  </Grid>
                                  {/* Price — always visible */}
                                  <Grid item xs={12} sm={3}>
                                    <TextField
                                      sx={{ width: "100%" }}
                                      name={`products[${index}].price`}
                                      type="text"
                                      label="Price*"
                                      onChange={(e) =>
                                        setFieldValue(
                                          `products[${index}].price`,
                                          e.target.value,
                                        )
                                      }
                                      value={valRow?.price}
                                      error={
                                        errors?.products?.[index]
                                          ? !!errors.products[index].price
                                          : false
                                      }
                                      helperText={
                                        errors?.products?.[index]
                                          ? errors.products[index].price
                                          : ""
                                      }
                                    />
                                  </Grid>

                                  {/* Add More button — first row only */}
                                  {index === 0 && (
                                    <Grid item xs={12} sm={1.5}>
                                      <Button
                                        variant="contained"
                                        size="small"
                                        sx={{ mt: 1.5 }}
                                        onClick={() =>
                                          pushRow({
                                            productId: null,
                                            supplierId: values.products[0].supplierId,
                                            gst: values.products[0].gst,
                                            mobileNumber: values.products[0].mobileNumber,
                                            price: "",
                                          })
                                        }
                                      >
                                        Add More
                                      </Button>
                                    </Grid>
                                  )}

                                  {/* Remove button — subsequent rows only */}
                                  {index !== 0 && (
                                    <Grid item xs={12} sm={2}>
                                      <IconButton
                                        size="large"
                                        onClick={() => removeRow(index)}
                                      >
                                        <Cancel />
                                      </IconButton>
                                    </Grid>
                                  )}
                                </Grid>
                              </div>
                            ))}
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <br></br>
                </div>
                <Stack
                  spacing={{ xs: 1, sm: 2 }}
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{ width: "100%" }}
                >
                  <LoadingButton
                    variant="outlined"
                    color="secondary"
                    size="large"
                    onClick={() => {
                      navigate(PARTY_RATE);
                    }}
                    fullWidth={mobileView}
                  >
                    Cancel
                  </LoadingButton>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    size="large"
                    loading={isSubmitting}
                    loadingIndicator={<CircularProgress size={20} />}
                    fullWidth={mobileView}
                  >
                    Save
                  </LoadingButton>
                </Stack>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </>
  );
};

export default AddPartyRate;
